import {
  getV1CompaniesCompanyIdTwilioIntegrations,
  postV1CompaniesCompanyIdTwilioIntegrations,
  TwilioRegion,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback, useState } from 'react';

import connection from '~services/connectionModule';

import { TwilioIntegration } from './models';

export const useTwilioIntegrations = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getTwilioIntegrations = useCallback(
    async (companyId: string, signal?: AbortSignal) => {
      setIsLoading(true);
      try {
        const response = await getV1CompaniesCompanyIdTwilioIntegrations({
          path: { 'company-id': companyId },
          signal,
        });
        return response.data.data.map(TwilioIntegration.parse);
      } catch (error) {
        connection.handleRequestError(
          error,
          t('error_messages.agents.failed_to_fetch_agents'),
        );
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  const createTwilioIntegration = useCallback(
    async (companyId: string, twilioRegion: TwilioRegion) => {
      try {
        const response = await postV1CompaniesCompanyIdTwilioIntegrations({
          path: { 'company-id': companyId },
          body: { twilio_region: twilioRegion },
        });
        return TwilioIntegration.parse(response.data.data);
      } catch (error) {
        connection.handleRequestError(
          error,
          t('error_messages.agents.failed_to_set_up_ticket_chasing'),
        );
      }
    },
    [],
  );

  return { createTwilioIntegration, getTwilioIntegrations, isLoading };
};
